import React from 'react';
import { Helmet } from 'react-helmet';
import logo from './images/icc-logo.png';
import Icon, { IconTypes } from './components/common/Icon';
import './AppMaintenance.scss';
//import MaintenanceTest from './components/maintenance/MaintenanceTest';


export default function Maintenance(props) {
  return (
    <div id="Maintenance">
      <Helmet>
        <title>Institute of Catholic Culture - Catholic Adult Education</title>
        <meta name="description" content="The Institute of Catholic Culture is an adult faith formation organization dedicated to the Church’s call for a new evangelization" />
      </Helmet>
      <div className="header">
        <img src={logo} alt="Institute of Catholic Culture Logo" />
      </div>
      <main>
        <Icon className="icon" type={IconTypes.Construction} />
        <h1>We're currently performing website maintenance</h1>
        <p>
          This maintenance window may last up to a few hours, and our website will be unavailable during this period. 
          Please check back with us in a little while.
        </p>
        <p>
          Thank you for your patience!
        </p>
        {/*<MaintenanceTest />*/}
      </main>
    </div>
  );
}
